import { InfoButton } from '$tablet-app/src/app/components/InfoButton';
import { ScreenHeader } from '$tablet-app/src/app/components/ScreenHeader';
import Text from '$tablet-app/src/app/components/Text';
import { VideoDialogAnchor } from '$tablet-app/src/app/videos/components/VideoDialogAnchor';
import { useCalendarInfoVideo } from '$tablet-app/src/app/videos/hooks/info_video_hooks';
import React from 'react';
import styled from 'styled-components/native';

type Props = {
  rightContent?: React.ReactNode;
};

const CalendarScreenHeader = (props: Props) => {
  const { data: info_video } = useCalendarInfoVideo();

  return (
    <ScreenHeader>
      <Left>
        <Text variant="h2" weight="semibold">
          Calendar
        </Text>

        {info_video?.value ? (
          <VideoDialogAnchor
            title="Calendar"
            source={{ drive_id: info_video.value }}
          >
            {(data) => <InfoButton onPress={data.showDialog} />}
          </VideoDialogAnchor>
        ) : null}
      </Left>
      <Right>{props.rightContent ? props.rightContent : null}</Right>
    </ScreenHeader>
  );
};

const Left = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const Right = styled.View`
  flex-direction: row;
  align-items: center;
  margin-left: auto;
`;

export default CalendarScreenHeader;
